import { EN_GLYPHS, EN_W, EN_H, T_GLYPH, T_W, T_H } from './logo-paths';

type Tone = 'ink' | 'paper' | 'current';
const fillFor = (t: Tone) => (t === 'ink' ? 'var(--color-ink)' : t === 'paper' ? 'var(--color-paper)' : 'currentColor');

/** The brand: Haya's "tempo" wordmark (heavy didone), English only, no symbol. Height in px; width follows. */
export function Wordmark({ height = 24, tone = 'ink', opacity = 1, title = 'tempo' }: { height?: number; tone?: Tone; opacity?: number; title?: string }) {
  return (
    <svg width={(EN_W / EN_H) * height} height={height} viewBox={`0 0 ${EN_W} ${EN_H}`} role="img" aria-label={title} style={{ display: 'block' }}>
      <g fill={fillFor(tone)} opacity={opacity}>{EN_GLYPHS.map((g, i) => <path key={i} d={g.d} transform={`translate(${g.tx},${g.ty})`} />)}</g>
    </svg>
  );
}

/** Small-size mark: the "t" of the same wordmark on a rounded square. Used only where the full word cannot fit (app icon, avatars). */
export function Mark({ size = 40, tone = 'ink' }: { size?: number; tone?: Exclude<Tone, 'current'> }) {
  const bg = tone === 'ink' ? 'var(--color-ink)' : 'var(--color-paper)';
  const fg = tone === 'ink' ? 'var(--color-paper)' : 'var(--color-ink)';
  const s = 0.6 * 100 / T_H, w = T_W * s, h = T_H * s;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label="tempo" style={{ display: 'block' }}>
      <rect width="100" height="100" rx="22" fill={bg} />
      <g transform={`translate(${(100 - w) / 2},${(100 - h) / 2}) scale(${s})`} fill={fg}><path d={T_GLYPH.d} transform={`translate(${T_GLYPH.tx},${T_GLYPH.ty})`} /></g>
    </svg>
  );
}
